export default function convertToDoc(data: string): Document {
	let tempDoc: Document = document.implementation.createHTMLDocument('temp');
	tempDoc.body.innerHTML = data;
	return tempDoc;
}
